var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        value: _vm.showMenu,
        "position-x": _vm.x,
        "position-y": _vm.y,
        absolute: "",
        "offset-y": "",
        "content-class": "splicing-menu"
      },
      on: { change: _vm.toggleMenu }
    },
    [
      _vm.showConnectionOrChange
        ? _c(
            "v-list",
            { attrs: { dense: "", id: "splicing-menu-list" } },
            [
              _c(
                "v-list-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("add-connection")
                    }
                  }
                },
                [
                  _c("v-list-item-title", [
                    _vm._v(
                      _vm._s(_vm.$t("Add")) +
                        " " +
                        _vm._s(_vm.$tc("Connection", 1))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("change-connection")
                    }
                  }
                },
                [
                  _c("v-list-item-title", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("Change")) +
                        " " +
                        _vm._s(_vm.$tc("Connection", 1)) +
                        "\n      "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm.state === "list"
        ? _c(
            "v-list",
            { attrs: { dense: "", id: "splicing-menu-list" } },
            [
              _c(
                "v-list-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("collapse-list-splitter")
                    }
                  }
                },
                [
                  _c(
                    "v-list-item-avatar",
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-arrow-collapse-vertical")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-item-title", [
                    _vm._v(
                      _vm._s(
                        _vm.isExpand ? _vm.$t("Expand") : _vm.$t("Collapse")
                      )
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("hide-list-splitter")
                    }
                  }
                },
                [
                  _c(
                    "v-list-item-avatar",
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-eye-off")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-item-title", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("HideEquipment")) +
                        "\n      "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("delete-splitter")
                    }
                  }
                },
                [
                  _c(
                    "v-list-item-avatar",
                    [_c("v-icon", { attrs: { left: "" } }, [_vm._v("delete")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-item-title", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("DeleteEquipment")) +
                        "\n      "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-list",
            { attrs: { dense: "", id: "splicing-menu-list" } },
            [
              _vm.state &&
              (_vm.state === "occupied" ||
                _vm.state === "split" ||
                _vm.state === "splitter") &&
              !_vm.disabled
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("inspect")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("manage_search")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("View") + " " + _vm.$tc("Connection", 1)
                          )
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.actionType === "edit" && _vm.state !== "free"
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("remove-connections")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("delete")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("Remove")) +
                            " " +
                            _vm._s(_vm.$tc("Connection", 2)) +
                            "\n      "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.state === "splitter"
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("view-splitter")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-eye")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("ShowEquipment")) +
                            "\n      "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.state === "splitter" && _vm.actionType === "edit"
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("edit-splitter")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("edit")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("EditEquipment")) +
                            "\n      "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.actionType === "edit" &&
              _vm.side !== "destination" &&
              (_vm.state === "free" || _vm.state === "splitter")
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("connect-to")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-transit-connection-variant")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [
                        _vm._v("\n        Connect to\n      ")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.actionType === "edit" &&
              _vm.side === "destination" &&
              _vm.isTechLocal &&
              _vm.state === "free"
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("connect-to")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-transit-connection-variant")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [
                        _vm._v("\n        Connect to\n      ")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isFiber && _vm.state !== "splitter"
                ? _c(
                    "v-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("show-circuit")
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("settings_input_composite")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-title", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("ShowFiberCircuit")) +
                            "\n      "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b1ca48b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1ca48b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionObjectMenu.vue
// module id = null
// module chunks = 